import { graphqlDynamic } from "react-apollo-dynamic-query"
import { connect } from "react-redux"
import { createMatchSelector } from "react-router-redux"
import gql from "graphql-tag"
import Header from "."
import routes from "../../routes"

const generateQuery = ({ entityType }) => gql`
  query HeaderWithRouteEntity($entityId: ID!) {
    entity: ${entityType}(id: $entityId) {
      id
      name
    }
  }
`

const HeaderWithApollo = graphqlDynamic(generateQuery, {
  options: ({ entityId }) => ({
    variables: { entityId },
  }),
  props: ({ data: { error, loading, entity } }) => {
    if (error) {
      throw error
    }
    if (!loading) {
      if (!entity) {
        throw Error("404")
      }

      return {
        entityName: entity.name,
      }
    }
  },
})(Header)

const HeaderWithRouteEntity = connect(({ router }) => {
  // This is a partial match for many of our routes, but the intent is to get the top-level entity.
  const match = createMatchSelector(routes.entity)({ router })
  return {
    location: router.location,
    entityType: match.params.entityType,
    entityId: match.params.entityId,
  }
})(HeaderWithApollo)

export default HeaderWithRouteEntity
